import { sh } from '@tpluscode/rdf-ns-builders';
import NodeExpression from './NodeExpression.js';
export class FocusNodeExpression extends NodeExpression {
    constructor() {
        super(...arguments);
        this.term = sh.this;
    }
    static match({ term }) {
        return term.equals(sh.this);
    }
    static fromPointer() {
        return new FocusNodeExpression();
    }
    get requiresFullContext() {
        return true;
    }
    get rootIsFocusNode() {
        return true;
    }
    _buildPatterns({ subject, object }) {
        return {
            type: 'bind',
            expression: subject,
            variable: object,
        };
    }
    buildInlineExpression(arg) {
        return {
            inline: arg.subject,
        };
    }
}
